interface KlaviyoRegisterUserProps {
  email?: string;
  firstName?: string;
  lastName?: string;
}

const klaviyoRegisterUser = ({
  email,
  firstName,
  lastName,
}: KlaviyoRegisterUserProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _learnq = [] } = window;
  _learnq.push([
    'identify',
    {
      $email: email,
      $first_name: firstName,
      $last_name: lastName,
    },
  ]);
};

export default klaviyoRegisterUser;
